/**
 * 数据模型
 * 所有数据模型类统一定义；对应后台DTO类
 * 解决问题：前端没有统一数据模型定义；而VUE数据绑定要求数据对象声明时、初始化所有字段；
 *        就导致每次初始化数据都需要定义字段默认值、而这些代码分散在业务逻辑的各个地方，难以维护
 */
export default {
  /* -------------人员------------- */
  BaseUser: function (obj, vm) {
    // --↓多条记录处理↓--
    if (vm && vm.$baize.isArray(obj)) {
      var result = []
      for (var objIndex = 0; objIndex < obj.length; objIndex++) {
        result.push(vm.$common.model.BaseUser(obj[objIndex], vm))
      }
      return result
    }
    // --↑多条记录处理↑--
    var defaultObj = {
      // 主键
      id: null,
      // 姓名
      name: null,
      // 头像
      photo: null
    }
    if (obj !== null && obj !== undefined) {
      for (var key in obj) {
        defaultObj[key] = obj[key]
      }
    }
    // --↓判断有修改↓--
    var _originalVal = {}
    for (var defaultObjKey in defaultObj) {
      _originalVal[defaultObjKey] = defaultObj[defaultObjKey]
    }
    defaultObj._originalVal = _originalVal
    defaultObj.isDirty = function (ignoreFields) {
      ignoreFields = ignoreFields || []
      for (var defaultObjKey in this) {
        if (defaultObjKey === '_originalVal' || defaultObjKey === 'isDirty' || ignoreFields.indexOf(defaultObjKey) >= 0) {
          continue
        }
        if (this._originalVal[defaultObjKey] !== this[defaultObjKey]) {
          return true
        }
      }
      return false
    }
    // --↑判断有修改↑--
    return defaultObj
  }
}



// WEBPACK FOOTER //
// ./src/common/src/Model.js